import React from 'react'


const Filter = ({ id, register, handleSubmit, onReset, districts = [], types = [], statuses = [], filters }) => {

  return (
    <form className="map__filter" onSubmit={handleSubmit}>
    <div className="map__filter-fields">
      <div className="map__filter-field">
          <input type="text" placeholder="Search" {...register('keywords', {
            value: filters.keywords
          })} inputMode="search" id={`keywords__${id}`} />
          <label htmlFor={`keywords__${id}`}>Search by lease name</label>
        </div>
        <div className="map__filter-field">
          <select id={`type__${id}`} {...register('type')}>
            <option value="">All</option>
            {types.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
          <label htmlFor={`type__${id}`}>Search by Crown property type</label>
        </div>
        <div className="map__filter-field">
          <select id={`district__${id}`} {...register('district')}>
            <option value="">All</option>
            {districts.map(district => <option key={district} value={district}>{district}</option>)}
          </select>
          <label htmlFor={`district__${id}`}>Search by district</label>
        </div>
        {/*
        <div className="map__filter-field">
          <div className="d-flex align-items-center gap-x-2">
            <input type="checkbox" id={`tenure`} {...register('tenure')} defaultValue={'1'} />
            <label className="mb-0" htmlFor={`tenure`}>In tenure review</label>
          </div>
        </div>
        <div className="map__filter-field">
          <select id={`stage__${id}`} {...register('stage')}>
            <option value="">All</option>
            {stages.map(stage => <option key={stage} value={stage}>{stage}</option>)}
          </select>
          <label htmlFor={`stage__${id}`}>Search by tenure review stage</label>
        </div>
        */}
      </div>

      <div className="map__filter-buttons">
        <button type="submit">Submit</button>
        <button type="button" onClick={onReset}>Reset</button>
      </div>
    </form>
  )
}
export default Filter
